<template>
    <div class="rankingTableWrapper">
        <table id="RankingTable">
            <thead>
                <tr>
                    <th @click="setOrder('rank')" class="th1">順位
                        <span v-if="isOrderAsc === 'rank_asc'">▲</span>
                        <span v-if="isOrderAsc === 'rank_desc'">▼</span>
                    </th>


                    <th class="th2">ID</th>


                    <th class="th3">商品名</th>

                    <template v-if="rankingTabActive != 0">
                        <th @click="setOrder('troas')">全体ROAS
                            <span v-if="isOrderAsc === 'troas_asc'">▲</span>
                            <span v-if="isOrderAsc === 'troas_desc'">▼</span>
                        </th>

                        <th class="tooltipsHover" @click="setOrder('roas')">サイトROAS
                            <span class="tooltipsIcon">?
                                <span class="tooltips">売上合計 ÷ 広告費合計 x 100</span>
                            </span>
                            <span v-if="isOrderAsc === 'roas_asc'">▲</span>
                            <span v-if="isOrderAsc === 'roas_desc'">▼</span>
                        </th>
                    </template>

                    <template v-if="rankingTabActive == 0">
                        <th class="tooltipsHover" @click="setOrder('roas')">全体ROAS
                            <span class="tooltipsIcon">?
                                <span class="tooltips">売上合計 ÷ 広告費合計 x 100</span>
                            </span>
                            <span v-if="isOrderAsc === 'roas_asc'">▲</span>
                            <span v-if="isOrderAsc === 'roas_desc'">▼</span>
                        </th>
                    </template>


                    <th @click="setOrder('sales')">売上合計<br class="nopc">（税抜）
                        <span v-if="isOrderAsc === 'sales_asc'">▲</span>
                        <span v-if="isOrderAsc === 'sales_desc'">▼</span>
                    </th>


                    <th @click="setOrder('units')">販売<br class="nopc">個数
                        <span v-if="isOrderAsc === 'units_asc'">▲</span>
                        <span v-if="isOrderAsc === 'units_desc'">▼</span>
                    </th>


                    <!-- ★セット★ -->
                    <th @click="setOrder('sales_ratio')">
                        期間比
                        <span v-if="isOrderAsc === 'sales_ratio_asc'">▲</span>
                        <span v-if="isOrderAsc === 'sales_ratio_desc'">▼</span>
                        <span class="shrinkBtn" @click="handleSpanClick"></span>
                    </th>


                    <template v-if="deploymented">
                        <th @click="setOrder('sales_diff')">差額
                            <span v-if="isOrderAsc === 'sales_diff_asc'">▲</span>
                            <span v-if="isOrderAsc === 'sales_diff_desc'">▼</span>
                        </th>
                    </template>
                    <!-- ★セット★ -->


                    <th @click="setOrder('ads')">広告費<br class="nopc">合計
                        <span v-if="isOrderAsc === 'ads_asc'">▲</span>
                        <span v-if="isOrderAsc === 'ads_desc'">▼</span>
                    </th>


                    <template v-if="isAccessable">
                        <th class="tooltipsHover" @click="setOrder('costs_product')">原価
                            <span class="tooltipsIcon">?
                                <span class="tooltips">売上原価 x 販売個数</span>
                            </span>
                            <span v-if="isOrderAsc === 'costs_product_asc'">▲</span>
                            <span v-if="isOrderAsc === 'costs_product_desc'">▼</span>
                        </th>


                        <template v-if="isAccessableDev">
                            <th class="tooltipsHover" @click="setOrder('cost_rate')">原価率
                                <span class="tooltipsIcon">?
                                    <span class="tooltips">原価 ÷ 売上合計</span>
                                </span>
                                <span v-if="isOrderAsc === 'cost_rate_asc'">▲</span>
                                <span v-if="isOrderAsc === 'cost_rate_desc'">▼</span>
                            </th>
                        </template>


                        <th class="tooltipsHover" @click="setOrder('costs_delivery')">送料
                            <span class="tooltipsIcon">?
                                <span class="tooltips">商品の送料 x 販売個数</span>
                            </span>
                            <span v-if="isOrderAsc === 'costs_delivery_asc'">▲</span>
                            <span v-if="isOrderAsc === 'costs_delivery_desc'">▼</span>
                        </th>


                        <th class="tooltipsHover" @click="setOrder('costs_charge')">手数料
                            <span class="tooltipsIcon">?
                                <span class="tooltips">売上 x (各サービスの手数料率 / 100 )</span>
                            </span>
                            <span v-if="isOrderAsc === 'costs_charge_asc'">▲</span>
                            <span v-if="isOrderAsc === 'costs_charge_desc'">▼</span>
                        </th>


                        <th class="tooltipsHover" @click="setOrder('mall_point')">ポイント<span class="tooltipsIcon">?<span
                                    class="tooltips">売上 x (
                                    ポイント倍率 / 100)</span></span>
                            <span v-if="isOrderAsc === 'mall_point_asc'">▲</span>
                            <span v-if="isOrderAsc === 'mall_point_desc'">▼</span>
                        </th>


                        <th class="tooltipsHover" @click="setOrder('costs')">費用<br class="nopc">合計
                            <span class="tooltipsIcon">?
                                <span class="tooltips">広告費 + 原価 + 送料 + 手数料</span>
                            </span>
                            <span v-if="isOrderAsc === 'costs_asc'">▲</span>
                            <span v-if="isOrderAsc === 'costs_desc'">▼</span>
                        </th>


                        <th class="tooltipsHover" @click="setOrder('margins')">粗利
                            <span class=" tooltipsIcon">?
                                <span class="tooltips">売上合計 - 費用合計</span>
                            </span>
                            <span v-if="isOrderAsc === 'margins_asc'">▲</span>
                            <span v-if="isOrderAsc === 'margins_desc'">▼</span>
                        </th>


                        <th class="tooltipsHover" @click="setOrder('margin_rate')">粗利率
                            <span class="tooltipsIcon">?
                                <span class="tooltips">粗利額 ÷ 売上合計 x 100</span>
                            </span>
                            <span v-if="isOrderAsc === 'margin_rate_asc'">▲</span>
                            <span v-if="isOrderAsc === 'margin_rate_desc'">▼</span>
                        </th>
                    </template>


                    <th v-if="rankingTabActive == 0">割合</th>


                    <th class="sp">在庫確認</th>
                </tr>
            </thead>
            <tbody class="selectRoasRow">
                <tr v-for="item in dispReports" :key="item['rank']"
                    v-on:click="openProductRoas(item, roas_start_date, end_date)">

                    <!-- 順位 -->
                    <td class="tal td1">{{ item["rank"] }}</td>
                    <!-- 順位 -->


                    <!-- ID -->
                    <!-- グループ商品の場合、商品IDを「Gr」と表示する -->
                    <!-- グループ商品の場合、明細の吹き出しを出す -->
                    <template v-if="item['is_group'] === 1">
                        <td v-on:click="$event => $event.stopPropagation()" class="balloon td2"
                            @click="openBalloon(item['rank'])">
                            <button class="btn grBtn">Gr</button>
                            <div class="balloon_area">
                                <div class="input-balloon" v-show="isFocused === item['rank']">
                                    <div class="balloon_flex">
                                        <template v-for="(group, index) in item['groups']">
                                            <div :key="index" class="baloon_item">
                                                <p>【{{ group }}】<br class="nopc">{{ item['groupsName'][index] }}</p>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </template>

                    <!-- 単品商品の場合、そのまま商品IDを表示 -->
                    <td class="tal td2" v-else>{{ item["id"] }}</td>
                    <!-- ID -->


                    <!-- 商品名 -->
                    <td class="td3">
                        <div class="productName">
                            <div class="productName_txt" style="width: 90%;">
                                <p>
                                    {{ item["name"] }}
                                </p>
                            </div>

                            <div class="productName_btn">
                                <template v-if="item['is_group'] == true">
                                    <button class="btn grBtn sp" v-on:click="$event => {
                                        $event.stopPropagation();
                                        selectedTarget.type = 'totalling';
                                        selectedTarget.totallingTarget.id = item['id'];
                                        showColorSizeRoas();
                                    }">SKU</button>
                                </template>

                                <template v-else>
                                    <button class="btn grBtn sp" v-on:click="$event => {
                                        $event.stopPropagation();
                                        selectedTarget.type = 'single';
                                        selectedTarget.product.id = item['id'];
                                        showColorSizeRoas();
                                    }">SKU</button>
                                </template>
                            </div>
                        </div>
                    </td>
                    <!-- 商品名 -->

                    <!-- 全体ROAS（サイト別表示のみ） -->
                    <template v-if="rankingTabActive != 0">
                        <td v-if="item['troas'] > 0" :class="roasColorClass(item['troas'])">
                            {{ Number(item["troas"]) | percentDisp }}
                        </td>
                        <td v-else>-</td>
                    </template>
                    <!-- 全体ROAS -->

                    <!-- ROAS合計 -->
                    <td v-if="item['ads'] > 0" :class="roasColorClass(item['roas'])">
                        {{ Number(item["roas"]) | percentDisp }}
                    </td>
                    <td v-else>-</td>
                    <!-- ROAS合計 -->

                    <!-- 売上合計 -->
                    <td>{{ Number(item["sales"]) | priceLocaleString }}</td>
                    <!-- 売上合計 -->


                    <!-- 販売個数 -->
                    <td>{{ Number(item["units"]) }}</td>
                    <!-- 販売個数 -->


                    <!-- ★セット★ -->
                    <!-- 期間比 -->
                    <td v-if="item['sales_ratio'] > 0" :class="ratioColorClass(item['sales_ratio'])">
                        {{ Number(item["sales_ratio"]) | percentDisp }}
                    </td>
                    <td v-else>-</td>
                    <!-- 期間比 -->


                    <!-- 差額 -->
                    <template v-if="deploymented">
                        <td>{{ Number(item["sales_diff"]) | priceLocaleString }}</td>
                    </template>
                    <!-- 差額 -->
                    <!-- ★セット★ -->


                    <!-- 広告費合計 -->
                    <td>{{ Number(item["ads"]) | priceLocaleString }}</td>
                    <!-- 広告費合計 -->


                    <!-- 管理者のみ表示 -->
                    <template v-if="isAccessable">
                        <!-- 原価 -->
                        <td>{{ Number(item["costs_product"]) | priceLocaleString }}</td>
                        <!-- 原価 -->


                        <!-- システム開発者のみ表示 -->
                        <template v-if="isAccessableDev">
                            <!-- 原価率 -->
                            <template v-if="item['costs_change_flg'] == 1">
                                <template v-if="item['is_group'] === 1">
                                    <td>
                                        <div class="costRatePosition">
                                            <span class="costRateIcon">■</span>
                                            <div>
                                                {{ Number(item["cost_rate"]) | percentDisp }}
                                            </div>
                                        </div>
                                    </td>
                                </template>

                                <template v-else>
                                    <td v-on:click="openProductMaster(item)">
                                        <div class="costRatePosition">
                                            <span class="costRateIcon">■</span>
                                            <div>
                                                {{ Number(item["cost_rate"]) | percentDisp }}
                                            </div>
                                        </div>
                                    </td>
                                </template>
                            </template>
                            <template v-else>
                                <td>
                                    {{ Number(item["cost_rate"]) | percentDisp }}
                                </td>
                            </template>
                            <!-- 原価率 -->
                        </template>
                        <!-- システム開発者のみ表示 -->


                        <!-- 送料 -->
                        <td>{{ Number(item["costs_delivery"]) | priceLocaleString }}</td>
                        <!-- 送料 -->


                        <!-- 手数料 -->
                        <td>{{ Number(item["costs_charge"]) | priceLocaleString }}</td>
                        <!-- 手数料 -->


                        <!-- ポイント -->
                        <td>{{ Number(item["mall_point"]) | priceLocaleString }}</td>
                        <!-- ポイント -->


                        <!-- 費用合計 -->
                        <td>{{ Number(item["costs"]) | priceLocaleString }}</td>
                        <!-- 費用合計 -->


                        <!-- 粗利 -->
                        <td>{{ Number(item["margins"]) | priceLocaleString }}</td>
                        <!-- 粗利 -->


                        <!-- 粗利率 -->
                        <td>{{ Number(item["margin_rate"]) | percentDisp }}</td>
                        <!-- 粗利率 -->
                    </template>


                    <!-- 割合 -->
                    <!-- 「全サイトタブ」の時のみ表示 -->
                    <td v-if="rankingTabActive == 0">
                        <dl class="bar-chart-002">
                            <dd>
                                <div class="graphHover">
                                    <span class="private_rate"
                                        :style="{ width: item['sales_private_rate'] + '%' }"></span>
                                    <span class="mall_rate" :style="{ width: item['sales_mall_rate'] + '%' }"></span>
                                    <span class="tooltips">
                                        自社&emsp;：{{ Number(item['sales_private']) | priceLocaleString }}<br>
                                        モール：{{ Number(item['sales_mall']) | priceLocaleString }}<br>
                                        店舗&emsp;：{{ Number(item['sales_shop']) | priceLocaleString }}
                                    </span>
                                </div>
                            </dd>
                        </dl>
                    </td>
                    <!-- 割合 -->


                    <!-- 在庫確認 -->
                    <td class="stock-link sp">
                        <!-- 親要素のイベントを無効化 -->
                        <a v-on:click="$event => $event.stopPropagation()" class="" :href="getAmStockLink(item)"
                            target="_blank">在庫確認</a>
                    </td>
                    <!-- 在庫確認 -->
                </tr>
            </tbody>
        </table>

        <!-- カラー・サイズ別ROAS表示用モーダル -->
        <modal name="colorSizeRoas" :draggable="false" :resizable="false" width="50%" height="85%">
            <ColorSizeRoasModal :type="this.selectedTarget.type" :productId="this.selectedTarget.product.id"
                :totallingTargetId="this.selectedTarget.totallingTarget.id" :dateBase="false"
                :startDate="this.start_date" :endDate="this.end_date" :serviceId="this.service_id"
                @modalClosed="hideModalcolorSizeRoas" />
        </modal>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
    </div>
</template>

<script>
import ColorSizeRoasModal from './ColorSizeRoasModal.vue'; //カラー・サイズ別ROAS表示用モーダル
export default {
    name: "RankingTable",
    data() {
        return {
            config: {},
            bg_danger: "bg-danger",
            isFocused: 0, //商品名の吹き出し制御
            lpProductId: null,
            lpProductName: "",
            isOrderAsc: this.isOrderAscRank,
            deploymented: false,
            selectedTarget: {
                type: 'single',
                product: { id: -1, name: '全商品', },
                totallingTarget: { id: null, name: null, products: null },
            },
        };
    },
    props: {
        ranking: Object,
        landingPages: Object,
        start_date: String,
        end_date: String,
        isAccessable: Boolean,
        isAccessableDev: Boolean,
        rankingTabActive: Number,
        isOrderAscRank: String,
        service_id: Array,
    },
    mounted: function () {
        this.axios.get("/api/configs")
            .then((res) => {
                this.config = res.data;
            }).catch(() => {
            });


        const th1_stickyElement = this.$el.querySelector(".th1");
        const th1_offsetwidth = th1_stickyElement.getBoundingClientRect().width;

        const th2_stickyElement = this.$el.querySelector(".th2");
        const th2_offsetwidth = th2_stickyElement.getBoundingClientRect().width;

        th2_stickyElement.style.left = `${th1_offsetwidth}px`;

        const td2_stickyElements = this.$el.querySelectorAll(".td2");
        td2_stickyElements.forEach(stickyElement => {
            stickyElement.style.left = `${th1_offsetwidth}px`;
        });


        const th3_offsetleft = parseFloat(th1_offsetwidth) + parseFloat(th2_offsetwidth);


        const th3_stickyElement = this.$el.querySelector(".th3");
        th3_stickyElement.style.left = `${th3_offsetleft}px`;

        const td3_stickyElements = this.$el.querySelectorAll(".td3");
        td3_stickyElements.forEach(stickyElement => {
            stickyElement.style.left = `${th3_offsetleft}px`;
        });
    },
    methods: {
        handleSpanClick(event) {
            event.stopPropagation();
            this.deploymentedDisp();
        },
        deploymentedDisp() {
            if (this.deploymented) {
                // 表を展開させた時
                this.deploymented = false
            } else {
                // 表を展開させなかった時
                this.deploymented = true
            }
        },
        // 商品別ROASを別タブで開く
        openProductRoas(item, start_date, end_date) {
            var url = "/roas_product?startDate=" + start_date + "&stopDate=" + end_date;
            // 商品グループ
            if (item["is_group"] === 1) {
                url += "&targetId=" + item["id"];
            }
            else {
                url += "&productId=" + item["id"];
            }
            window.open(url, "_blank");
        },
        // 商品マスタを別タブで開く
        openProductMaster(item) {
            var url = "/product_master?";

            // 商品グループ
            if (item["is_group"] === 1) {
                url += "&targetId=" + item["id"];
            }
            else {
                url += "&productId=" + item["id"];
            }

            url += "&productName=" + item["name"];

            window.open(url, "_blank");
        },
        roasColorClass(roas) {
            if (roas <= this.config.roas_danger) {
                return "bg-danger";
            }
            else if (roas >= this.config.roas_success) {
                return "bg-success";
            }
            return "";
        },
        ratioColorClass(ratio) {
            if (ratio >= 100) {
                return "ratio_blue";
            }
            else {
                return "ratio_red";
            }
        },
        getAmStockLink(product) {
            var link = this.$helpers.am_url() + "/salesManagement";
            var query = "?pageLimit=100&gummiId=";
            var ids = [];
            // 商品グループをばらす
            if (product.is_group === 1) {
                ids = ids.concat(product.groups);
            }
            else {
                ids.push(product.id);
            }
            for (var id of ids) {
                query += id + ",";
            }
            // 末尾のカンマを取り除いて結合
            link += query.substring(0, query.length - 1);
            return link;
        },
        //商品名の吹き出し表示
        //選択された順位を引数とし、対象の順位のみ吹き出しが出るようにする
        //同じ商品名をクリックしたら閉じる
        openBalloon(target) {
            if (this.isFocused !== target) {
                this.isFocused = target;
            }
            else {
                this.isFocused = 0;
            }
        },
        showLandingPage() {
            this.modalShow = true;
            this.$modal.show('lpModal');
        },
        LandingPageClosed() {
            this.modalShow = false;
            this.$modal.hide('lpModal');
        },
        //カラー・サイズ別ROASモーダル
        showColorSizeRoas() {
            this.$modal.show('colorSizeRoas')
        },
        hideModalcolorSizeRoas() {
            this.$modal.hide('colorSizeRoas')
        },
        //ポイント施策（小数点は切り捨て）
        truncate(number) {
            return Math.floor(number); // or Math.ceil(number) for rounding up
        },
        //ソート
        setOrder(target) {
            //順位
            if (target == "rank") {
                if (this.isOrderAsc == "rank_asc" || this.isOrderAsc == "sales_desc" || this.isOrderAsc == "roas_desc") {
                    this.isOrderAsc = "rank_desc"
                }
                else {
                    this.isOrderAsc = "rank_asc"
                }
            }

            //売上合計
            else if (target == "sales") {
                if (this.isOrderAsc == "sales_desc" || (this.isOrderAscRank == "sales_desc" && this.isOrderAsc == "rank_asc")) {
                    this.isOrderAsc = "sales_asc"
                }
                else {
                    this.isOrderAsc = "sales_desc"
                }
            }

            //期間比
            else if (target == "sales_ratio") {
                if (this.isOrderAsc == "sales_ratio_desc") {
                    this.isOrderAsc = "sales_ratio_asc"
                }
                else {
                    this.isOrderAsc = "sales_ratio_desc"
                }
            }

            //差額
            else if (target == "sales_diff") {
                if (this.isOrderAsc == "sales_diff_desc") {
                    this.isOrderAsc = "sales_diff_asc"
                }
                else {
                    this.isOrderAsc = "sales_diff_desc"
                }
            }

            //販売個数
            else if (target == "units") {
                if (this.isOrderAsc == "units_desc") {
                    this.isOrderAsc = "units_asc"
                }
                else {
                    this.isOrderAsc = "units_desc"
                }
            }

            //広告費合計
            else if (target == "ads") {
                if (this.isOrderAsc == "ads_desc") {
                    this.isOrderAsc = "ads_asc"
                }
                else {
                    this.isOrderAsc = "ads_desc"
                }
            }

            //ROAS
            else if (target == "roas") {
                if (this.isOrderAsc == "roas_desc" || (this.isOrderAscRank == "roas_desc" && this.isOrderAsc == "rank_asc")) {
                    this.isOrderAsc = "roas_asc"
                }
                else {
                    this.isOrderAsc = "roas_desc"
                }
            }

            //全体ROAS（サイト別表示のみ）
            else if (target == "troas") {
                if (this.isOrderAsc == "troas_desc") {
                    this.isOrderAsc = "troas_asc"
                }
                else {
                    this.isOrderAsc = "troas_desc"
                }
            }

            //原価
            else if (target == "costs_product") {
                if (this.isOrderAsc == "costs_product_desc") {
                    this.isOrderAsc = "costs_product_asc"
                }
                else {
                    this.isOrderAsc = "costs_product_desc"
                }
            }

            //原価率
            else if (target == "cost_rate") {
                if (this.isOrderAsc == "cost_rate_desc") {
                    this.isOrderAsc = "cost_rate_asc"
                }
                else {
                    this.isOrderAsc = "cost_rate_desc"
                }
            }

            //送料
            else if (target == "costs_delivery") {
                if (this.isOrderAsc == "costs_delivery_desc") {
                    this.isOrderAsc = "costs_delivery_asc"
                }
                else {
                    this.isOrderAsc = "costs_delivery_desc"
                }
            }

            //手数料
            else if (target == "costs_charge") {
                if (this.isOrderAsc == "costs_charge_desc") {
                    this.isOrderAsc = "costs_charge_asc"
                }
                else {
                    this.isOrderAsc = "costs_charge_desc"
                }
            }

            //ポイント
            else if (target == "mall_point") {
                if (this.isOrderAsc == "mall_point_desc") {
                    this.isOrderAsc = "mall_point_asc"
                }
                else {
                    this.isOrderAsc = "mall_point_desc"
                }
            }

            //費用合計
            else if (target == "costs") {
                if (this.isOrderAsc == "costs_desc") {
                    this.isOrderAsc = "costs_asc"
                }
                else {
                    this.isOrderAsc = "costs_desc"
                }
            }

            //粗利
            else if (target == "margins") {
                if (this.isOrderAsc == "margins_desc") {
                    this.isOrderAsc = "margins_asc"
                }
                else {
                    this.isOrderAsc = "margins_desc"
                }
            }

            //粗利率
            else if (target == "margin_rate") {
                if (this.isOrderAsc == "margin_rate_desc") {
                    this.isOrderAsc = "margin_rate_asc"
                }
                else {
                    this.isOrderAsc = "margin_rate_desc"
                }
            }
        }
    },
    computed: {
        // 終了日から30日分表示する
        roas_start_date: {
            get: function () {
                var date = this.$dayjs(this.end_date).subtract(30, 'days');
                return date.format("YYYY-MM-DD");
            }
        },

        //ランキングソート
        dispReports: function () {
            let reportsArray = Object.values(this.ranking);

            //順位
            if (this.isOrderAsc == "rank_desc") {
                return reportsArray.sort((a, b) => b.rank - a.rank);
            }
            else if (this.isOrderAsc == "rank_asc") {
                return reportsArray.sort((a, b) => a.rank - b.rank);
            }

            //売上合計
            else if (this.isOrderAsc == "sales_desc") {
                return reportsArray.sort((a, b) => b.sales - a.sales);
            }
            else if (this.isOrderAsc == "sales_asc") {
                return reportsArray.sort((a, b) => a.sales - b.sales);
            }

            //期間比
            else if (this.isOrderAsc == "sales_ratio_desc") {
                return reportsArray.sort((a, b) => b.sales_ratio - a.sales_ratio);
            }
            else if (this.isOrderAsc == "sales_ratio_asc") {
                return reportsArray.sort((a, b) => a.sales_ratio - b.sales_ratio);
            }

            //差額
            else if (this.isOrderAsc == "sales_diff_desc") {
                return reportsArray.sort((a, b) => b.sales_diff - a.sales_diff);
            }
            else if (this.isOrderAsc == "sales_diff_asc") {
                return reportsArray.sort((a, b) => a.sales_diff - b.sales_diff);
            }

            //販売個数
            else if (this.isOrderAsc == "units_desc") {
                return reportsArray.sort((a, b) => b.units - a.units);
            }
            else if (this.isOrderAsc == "units_asc") {
                return reportsArray.sort((a, b) => a.units - b.units);
            }

            //広告費合計
            else if (this.isOrderAsc == "ads_desc") {
                return reportsArray.sort((a, b) => b.ads - a.ads);
            }
            else if (this.isOrderAsc == "ads_asc") {
                return reportsArray.sort((a, b) => a.ads - b.ads);
            }

            //ROAS
            else if (this.isOrderAsc == "roas_desc") {
                return reportsArray.sort((a, b) => b.roas - a.roas);
            }
            else if (this.isOrderAsc == "roas_asc") {
                return reportsArray.sort((a, b) => a.roas - b.roas);
            }

            //全体ROAS（サイト別表示のみ）
            else if (this.isOrderAsc == "troas_desc") {
                return reportsArray.sort((a, b) => b.troas - a.troas);
            }
            else if (this.isOrderAsc == "troas_asc") {
                return reportsArray.sort((a, b) => a.troas - b.troas);
            }

            //原価
            else if (this.isOrderAsc == "costs_product_desc") {
                return reportsArray.sort((a, b) => b.costs_product - a.costs_product);
            }
            else if (this.isOrderAsc == "costs_product_asc") {
                return reportsArray.sort((a, b) => a.costs_product - b.costs_product);
            }

            //原価率
            else if (this.isOrderAsc == "cost_rate_desc") {
                return reportsArray.sort((a, b) => b.cost_rate - a.cost_rate);
            }
            else if (this.isOrderAsc == "cost_rate_asc") {
                return reportsArray.sort((a, b) => a.cost_rate - b.cost_rate);
            }

            //送料
            else if (this.isOrderAsc == "costs_delivery_desc") {
                return reportsArray.sort((a, b) => b.costs_delivery - a.costs_delivery);
            }
            else if (this.isOrderAsc == "costs_delivery_asc") {
                return reportsArray.sort((a, b) => a.costs_delivery - b.costs_delivery);
            }

            //手数料
            else if (this.isOrderAsc == "costs_charge_desc") {
                return reportsArray.sort((a, b) => b.costs_charge - a.costs_charge);
            }
            else if (this.isOrderAsc == "costs_charge_asc") {
                return reportsArray.sort((a, b) => a.costs_charge - b.costs_charge);
            }

            //ポイント
            else if (this.isOrderAsc == "mall_point_desc") {
                return reportsArray.sort((a, b) => b.mall_point - a.mall_point);
            }
            else if (this.isOrderAsc == "mall_point_asc") {
                return reportsArray.sort((a, b) => a.mall_point - b.mall_point);
            }

            //費用合計
            else if (this.isOrderAsc == "costs_desc") {
                return reportsArray.sort((a, b) => b.costs - a.costs);
            }
            else if (this.isOrderAsc == "costs_asc") {
                return reportsArray.sort((a, b) => a.costs - b.costs);
            }

            //粗利
            else if (this.isOrderAsc == "margins_desc") {
                return reportsArray.sort((a, b) => b.margins - a.margins);
            }
            else if (this.isOrderAsc == "margins_asc") {
                return reportsArray.sort((a, b) => a.margins - b.margins);
            }

            //粗利率
            else if (this.isOrderAsc == "margin_rate_desc") {
                return reportsArray.sort((a, b) => b.margin_rate - a.margin_rate);
            }
            else if (this.isOrderAsc == "margin_rate_asc") {
                return reportsArray.sort((a, b) => a.margin_rate - b.margin_rate);
            }

            //その他
            else {
                return this.ranking
            }

        },
    },
    components: { ColorSizeRoasModal, }
}
</script>

<style scoped lang="sass">
.bg-danger
    background-color: #ffcdd2
    color: red
.bg-success
    background-color: #bbdefb
    color: blue
.ratio_red
    color: red
.ratio_blue
    color: blue
.rankA
    background-color: #bbdefb
    color: blue
.rankB
    background-color: #BBFAD8
    color: #4D6658
.rankC
    background-color: #DEFABB
    color: #5B664D
.rankD
    background-color: #FAF7BB
    color: #66654D
.rankE
    background-color: #ffcdd2
    color: red
.tac
    text-align: center !important
.tal
    text-align: left !important
.nopc
    display: none
.rankingTableWrapper
    flex: 1 1 auto
    width: 100%
    min-width: 0
#RankingTable
    position: relative
    z-index: 1
    width: 100%
    border-collapse: separate
    margin: 0px auto
    white-space: nowrap
    th
        position: relative
        background: $grayColor
        border: 1px solid #bbb
        color: $whiteColor
        padding: 10px 5px
        text-align: center
        top: 0
        cursor: pointer
        vertical-align: middle
        .otherMedium
            border-bottom: double
    thead
        position: sticky
        top: 0
        width: 100%
        z-index: 9999
        .tooltipsHover
            &:hover .tooltips
                visibility: visible
                opacity: 1
                transition: .3s
        .tooltipsIcon
            position: relative
            display: inline-block
            width: 13px
            height: 13px
            border-radius: 13px
            margin-left: 3px
            text-align: center
            background-color: $whiteColor
            color: $grayColor
            font-weight: bold
            font-size: 1.1rem
            line-height: 16px
        .tooltips
            visibility: hidden
            opacity: 0
            position: absolute
            top: 33px
            right: -11px
            z-index: 999
            padding: 10px
            background-color: $whiteColor
            border-radius: 5px
            box-shadow: 3px 3px 2px rgba(0, 0, 0, .5)
            color: $grayColor
            font-size: 1.2rem
            font-weight: normal
            transition: .3s
            &:before
                content: ""
                position: absolute
                top: -10px
                right: 13px
                margin-left: -5px
                border: 5px solid transparent
                border-bottom: 5px solid $whiteColor
        th:first-child
            position: sticky !important
            top: 0 !important
            left: 0
            z-index: 4
        th:nth-child(2)
            position: sticky !important
            top: 0 !important
            left: 0
            z-index: 4
        th:nth-child(3)
            position: sticky !important
            top: 0 !important
            left: 0
            z-index: 4
    tbody
        .bar-chart-002
            dd
                position: relative;
                width: 80px;
                margin: 0 auto;
                background-color: #D6D885;
                height: 12px;
                &:hover .tooltips
                    visibility: visible
                    opacity: 1
                    transition: opacity 0.3s ease-in-out, visibility 0s 0.3s;
            .graphHover
                position: relative
                display: flex
                .tooltips
                    visibility: hidden
                    opacity: 0
                    position: absolute
                    top: -50px
                    left: 0
                    z-index: 9999
                    padding: 10px
                    background-color: $whiteColor
                    border-radius: 5px
                    box-shadow: 3px 3px 2px rgba(0, 0, 0, .5)
                    color: $grayColor
                    font-size: 1.2rem
                    text-align: left
                    font-weight: normal
                    transition: opacity 0.3s ease-in-out;
                    &:before
                        content: ""
                        position: absolute
                        bottom: -5px
                        left: 20px
                        margin-left: -5px
                        border: 5px solid transparent
                        border-top: 5px solid $whiteColor
                .private_rate
                    display: block;
                    height: 12px;
                    background-color: #02ad90;
                .mall_rate
                    display: block;
                    height: 12px;
                    background-color: #9ecf97;
        tr
            background: $whiteColor
            cursor: pointer
            &:hover
                background: #c8f0e8
                .bg-danger, .bg-success
                    color: black
                    background: #c8f0e8
        tr:nth-child(odd)
            background: #eee
            td:nth-child(1), td:nth-child(2), td:nth-child(3)
                background: #eee
            &:hover
                background: #c8f0e8
                td:nth-child(1), td:nth-child(2), td:nth-child(3)
                    background: #c8f0e8
        tr:nth-child(even)
            td:nth-child(1), td:nth-child(2), td:nth-child(3)
                background: #fff
            &:hover
                td:nth-child(1), td:nth-child(2), td:nth-child(3)
                    background: #c8f0e8
        td:nth-child(1)
            position: sticky !important
            left: 0
            z-index: 999
        td:nth-child(2)
            position: sticky !important
            left: 0
            z-index: 999
        td:nth-child(3)
            position: sticky !important
            left: 0
            z-index: 999
.costRatePosition
    display: flex;
    justify-content: space-between;
.costRateIcon
    color: red
    font-weight: bold
.grBtn
    display: block
    text-align: center
    vertical-align: middle
    text-decoration: none
    border: 1px solid $mainColor
    background: $mainColor
    color: $whiteColor
    height: 21px
    width: 36px
    margin: -4px
    padding: 0
.balloon
    z-index: 5555 !important
.balloon_area
    position: relative
    .input-balloon
        position: absolute
        left: 310px
        top: -25px
        padding: 5px
        background: #fff
        border: 1px solid $mainColor
        &::before
            content: ''
            position: absolute
            left: -16px
            top: 15px
            display: block
            width: 0
            height: 0
            border-left: 16px solid transparent
            border-top: 16px solid $mainColor
        &::after
            content: ""
            position: absolute
            left: -14px
            top: 16px
            display: block
            width: 0
            height: 0
            border-left: 15px solid transparent
            border-top: 15px solid white
        .baloon_item
            display: flex
            justify-content: space-between
            margin: 5px
            p
                margin-right: 8px
.selectRoasRow
    color: $grayColor
    position: relative
    td
        border: 1px solid #bbb
        padding: 5px
        text-align: right
        .productName
            display: flex
            justify-content: space-between
            align-items: center;
            .productName_txt
                display: flex;
                align-items: center;
            .productName_btn
                display: flex;
                gap: 13px;
                align-items: center;
    td.stock-link
        cursor: pointer
        text-align: center
        padding: 0
        a
            display: inline-block
            font-weight: 700
            width: 100%
            height: 100%
            color: #02AD90
            text-decoration: underline #02AD90
        a:hover
            color: black
    .dayField
        text-align: left
        &.isHoliday, &.isSunday
            color: #f55
        &.isSaturday
            color: #55f
.shrinkBtn
    background: #444
    border: 1px solid #fff
    cursor: pointer
    display: block
    height: 15px
    overflow: hidden
    position: relative
    width: 30px
    &::before
        background: #00ad90
        content: ''
        height: 13px
        position: absolute
        right: 0
        top: 0
        transform: translateX(75%)
        transition: all .3s ease-in-out
        width: 30px
    &::after
        border-bottom: 1px solid #fff
        border-right: 1px solid #fff
        content: ''
        display: block
        height: 5px
        position: absolute
        right: 12px
        top: 50%
        transform: rotate(135deg) translateY(-50%)
        transition: all .4s ease-in-out
        transform-origin: 50% 0
        width: 5px
    &:hover
        &::before
            transform: translateX(0%)
@include sp()
    .sp
        display: none !important
    .nopc
        display: block
    .rankA
        background-color: #bbdefb !important
        color: blue
    .rankB
        background-color: #BBFAD8 !important
        color: #4D6658
    .rankC
        background-color: #DEFABB !important
        color: #5B664D
    .rankD
        background-color: #FAF7BB !important
        color: #66654D
    .rankE
        background-color: #ffcdd2 !important
        color: red
    #RankingTable
        font-size: 12px
    thead
        th:first-child
            position: sticky !important
            top: 0 !important
            left: 0
            z-index: 4
        th:nth-child(2)
            position: sticky !important
            top: 0 !important
            left: 0
            z-index: 4
        th:nth-child(3)
            position: sticky !important
            top: 0 !important
            left: 0
            z-index: 4
    tbody
        tr:nth-child(odd)
            td:nth-child(1), td:nth-child(2), td:nth-child(3)
                background: #eee
            &:hover
                td:nth-child(1), td:nth-child(2), td:nth-child(3)
                    background: #c8f0e8
        tr:nth-child(even)
            td:nth-child(1), td:nth-child(2), td:nth-child(3)
                background: #fff
            &:hover
                td:nth-child(1), td:nth-child(2), td:nth-child(3)
                    background: #c8f0e8
        td:nth-child(1)
            position: sticky !important
            left: 0
        td:nth-child(2)
            position: sticky !important
            left: 0
        td:nth-child(3)
            position: sticky !important
            left: 0
        .productName
            max-width: 140px
            overflow: hidden
    .balloon_area
        position: sticky !important
        .input-balloon
            position: absolute
            left: 120px
            top: -25px
            padding: 5px 0
            background: #fff
            border: 1px solid $mainColor
            width: 120px
            white-space: normal
            text-align: left !important
            &::before
                content: ''
                position: absolute
                left: -16px
                top: 15px
                display: block
                width: 0
                height: 0
                border-left: 16px solid transparent
                border-top: 16px solid $mainColor
            &::after
                content: ""
                position: absolute
                left: -14px
                top: 16px
                display: block
                width: 0
                height: 0
                border-left: 15px solid transparent
                border-top: 15px solid white
</style>
